import { render, staticRenderFns } from "./TeachUnit.vue?vue&type=template&id=125d9550&scoped=true&"
import script from "./TeachUnit.vue?vue&type=script&lang=js&"
export * from "./TeachUnit.vue?vue&type=script&lang=js&"
import style0 from "./TeachUnit.vue?vue&type=style&index=0&id=125d9550&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d9550",
  null
  
)

export default component.exports